import { render, staticRenderFns } from "./MarketTerminateModal_old.vue?vue&type=template&id=4a708a07&scoped=true"
import script from "./MarketTerminateModal_old.vue?vue&type=script&lang=js"
export * from "./MarketTerminateModal_old.vue?vue&type=script&lang=js"
import style0 from "./MarketTerminateModal_old.vue?vue&type=style&index=0&id=4a708a07&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a708a07",
  null
  
)

export default component.exports